<ion-accordion-group  expand="inset">
  <ion-accordion value="accordionAttachmentDocument">
    <ion-item slot="header" color="easie">
      <ion-label><i class="fas fa-paperclip"></i> &nbsp; Attach Documents</ion-label>
    </ion-item>
    <div class="ion-padding" slot="content">
      <ion-grid>
        <div class="row" *ngIf="!allowedUploadDocument">
          <div class="col text-center">
            <p><i class="fas fa-info-circle"></i>&nbsp;<span> You are not authorised to perform this
                operation.</span></p>
          </div>
        </div>
        <div class="row" *ngIf="allowedUploadDocument && exceedMaxLimit">
          <div class="col text-center">
            <p><i class="fas fa-info-circle"></i>&nbsp;<span> You have reached maximum limit.</span></p>
          </div>
        </div>
        <ion-row *ngIf="allowedUploadDocument && !exceedMaxLimit">
          <ion-col size="12">
            <div class="row align-middle text-center">
              <div class="col align-middle text-center">
                <div *ngIf="files.length == 0" class="custom-dropzone" ngx-dropzone (change)="onSelect($event)">
                  <ngx-dropzone-label>
                    <div>
                      <h6>Tap/Drop here to add your Document</h6>
                      <h6>Word/Excel/pdf formats supported</h6>
                    </div>
                  </ngx-dropzone-label>
                </div>
                <span *ngIf="!isImageSelected">
                  <ngx-dropzone-preview class="easie-dropzone" ngProjectAs="ngx-dropzone-preview"
                    *ngFor="let f of files" [file]="f" [removable]="true" (removed)="onRemove(f)">
                    <ngx-dropzone-label>
                      {{ f.name }} &nbsp;
                      <button type="button" class="btn btn-outline-danger btn-sm btn-block" (click)="onRemove(f)">
                        <i class="fas fa-trash"></i>
                      </button>
                    </ngx-dropzone-label>
                  </ngx-dropzone-preview>
                </span>
                <span *ngIf="isImageSelected">
                  <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngFor="let f of files" [file]="f"
                    [removable]="true" (removed)="onRemove(f)">
                    <ngx-dropzone-label>
                      <button type="button" class="btn btn-outline-danger btn-sm btn-block" (click)="onRemove(f)">
                        <i class="fas fa-trash"></i>
                      </button>
                    </ngx-dropzone-label>
                  </ngx-dropzone-image-preview>
                </span>
              </div>
            </div>
            <div class="container my-2">
              <div class="row easie-form" *ngIf="files.length > 0">
                <div class="col-12 mx-auto p-2">
                  <label class="field-label" for="caption">Caption</label>
                  <input type="text" id="caption" class="form-control" [(ngModel)]="caption">
                </div>
              </div>
            </div>
          </ion-col>
          <ion-col size="12">
            <ion-button *ngIf="files.length > 0" (click)="uploadAttachment()" expand="block" class="text-white">
              <i class="fas fa-cloud-upload-alt"></i> &nbsp; Upload Attachment
            </ion-button>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item-sliding *ngFor="let attachment of attachmentsWithName; let i = index;">
              <ion-item lines="none" (click)="download(attachment)">
                <ion-thumbnail slot="start" *ngIf="isAttachmentImage(attachment)">
                  <img src="{{attachment.url}}">
                </ion-thumbnail>
                <i class="far fa-file-pdf fa-2x color-brand-danger" *ngIf="isPdf(attachment)"></i>
                <i class="far fa-file-word fa-2x text-primary" *ngIf="isWord(attachment)"></i>
                <i class="far fa-file-excel fa-2x color-brand-success" *ngIf="isExcel(attachment)"></i>
                <ion-label>
                  <ion-text color="primary">
                    <h3>&nbsp; {{attachment.fileName}}</h3>
                  </ion-text>
                  <p>&nbsp; {{attachment.caption}}</p>
                </ion-label>
                <i class="fas fa-angle-double-left"></i>
              </ion-item>
              <ion-item-options side="end">
                <ion-item-option color="success"
                  (click)="editCaption(attachment.key, attachment.caption, attachment)">
                  <i class="fas fa-edit"></i>
                </ion-item-option>
                <ion-item-option color="danger" (click)="remove(attachment.url)">
                  <i class="fas fa-trash"></i>
                </ion-item-option>
              </ion-item-options>
            </ion-item-sliding>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </ion-accordion>
</ion-accordion-group>
<!-- <div id="accordionAttachmentDocument" class="p-2">
  <div class="card box-shadow border-info">
    <div class="card-header bg-info-easie text-white p-0" id="headingOneAttachment">
      <button [disabled]="!subscriptionStatus" class="btn btn-block text-white" data-toggle="collapse"
        data-target="#collapseOneAttachmentDocuments" aria-expanded="true"
        aria-controls="collapseOneAttachmentDocuments" (click)="sectionOpen = !sectionOpen">
        <i class="fas fa-paperclip"></i> &nbsp; Attach Documents &nbsp;<i
          [class]="sectionOpen ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
      </button>
    </div>

    <div id="collapseOneAttachmentDocuments" class="collapse" aria-labelledby="headingOneAttachment"
      data-parent="#accordionAttachmentDocument">
      <div class="card-body segment-label p-1">
        
      </div>
    </div>
  </div>
</div> -->